import { motion } from "framer-motion";
import { Instagram, Twitter, Youtube, Palette } from "lucide-react";

const SOCIAL_ICONS = {
  Instagram: Instagram,
  "X / Twitter": Twitter,
  YouTube: Youtube,
  ArtStation: Palette,
};

const SOCIAL_URLS = {
  Instagram: "https://www.instagram.com/ashvoltstudios",
  "X / Twitter": "https://x.com/ashvoltstudios",
  YouTube: "https://www.youtube.com/@ashvoltstudios",
  ArtStation: "https://www.artstation.com/ashvoltstudios",
};

export default function Footer({ data, brand }) {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 pt-20 md:pt-28 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <div className="flex items-baseline gap-3">
            <h3 className="font-heading uppercase text-[18vw] md:text-[16vw] lg:text-[14vw] text-white leading-[0.85] tracking-tighter">
              {brand.name}
            </h3>
            <span className="font-heading text-4xl md:text-6xl lg:text-7xl text-accent">★</span>
          </div>
          <p className="font-body text-sm md:text-base text-white/50 max-w-md mt-2">
            {brand.tagline}
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 pt-10 border-t border-white/10">
          <div>
            <div className="font-body text-[10px] uppercase tracking-[0.3em] text-accent mb-4">
              Seguici
            </div>
            <ul className="flex flex-wrap gap-4">
              {data.socials.map((s) => {
                const Icon = SOCIAL_ICONS[s] || Instagram;
                const url = SOCIAL_URLS[s] || "#";
                return (
                  <li key={s}>
                    <a
                      data-testid={`social-${s.replace(/[^a-z]/gi, "").toLowerCase()}`}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group inline-flex items-center gap-3 font-body text-sm text-white/70 hover:text-accent transition-colors border border-white/15 hover:border-accent/60 px-4 py-2.5"
                    >
                      <Icon size={14} />
                      <span className="tracking-[0.15em] uppercase text-[11px]">{s}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="font-body text-[11px] text-white/40 whitespace-nowrap">
            {data.copyright}
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 py-8">
          <p className="font-body text-[11px] text-white/40 leading-relaxed max-w-4xl">
            {data.trademarks}
          </p>
        </div>
      </div>
    </footer>
  );
}
